import { NgModule } from '@angular/core';
import { ServiceOrderService } from './service-order.service';
import { ServiceOrderBackend } from './service-order.backend';

@NgModule({
  providers: [ServiceOrderService, ServiceOrderBackend],
})
export class ServiceOrderModule {}
